<template>
	<div class="bg-white all margin-left padding-lr">
		<textarea name="" v-model="cont" id="" :disabled="idisable" maxlength="300" class="text-999 padding-xs fu-fs26 margin-top" placeholder-class="text-999 fu-fs26" placeholder="请简要描述您的理由"></textarea>
		<div class="">
			<div class="sub-btn text-white text-center bg-theme" v-if="status == 1">审核中</div>
			<div class="sub-btn text-white text-center pointer bg-theme" v-if="status == 0 || status == 3" @click="sub">立即提交</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				cont:'',
				status:0,
				idisable:false
			}
		},
		created() {
			this.getuserTeacher()
		},
		methods: {
			getuserTeacher(){
				this.ajax('get', '/api/userTeacher/getInfo',{}, res => {
					if(res.status == 200){
						this.cont = res.data.content||''
						this.status = res.data.status||0
						if(this.status == 0 || this.status == 3){
							this.idisable = false
						}else{
							this.idisable = true
						}
					}else{
						this.$message(res.msg);
					}
				})
			},
			sub(){
				console.log(this.cont);
				this.ajax('post', '/api/userTeacher/upReal',{
					content:this.cont
				}, res => {
					if(res.status == 200){
						this.$message.success('提交成功');
						this.getuserTeacher()
					}else{
						this.$message(res.msg);
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.all {
		width: 921px;
		height: 878px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204, 204, 204, 0.2000);
		border-radius: 20px;
		padding-top: 40px;
	}
	textarea{
		width: 700px;
		height: 200px;
		border: 1px solid #E6E6E6;
	}
	.sub-btn{
		margin: 32px auto;
		width: 383px;
		height: 46px;
		line-height: 46px;
		box-shadow: 3rpx 4rpx 38rpx 2rpx rgba(9, 130, 123, 0.2);
		border-radius: 23px;
	}
</style>


// WEBPACK FOOTER //
// src/components/my/authority/index.vue